import React, { useState, useEffect } from "react";
import { sendHealthChecks } from "../services/api";
import theme from '../theme';

const HealthCheck = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const handleFetchHealth = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await sendHealthChecks();
      setServices(result.statuses);
      if (!result.success) {
        setError(result.message);
      }
    } catch (err) {
      setError(`Failed to load: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchHealth();
  }, []);

  return (
    <div className={`p-8 ${theme.pageBg} min-h-screen`}>
      <div className="max-w-xl mx-auto">
        <h1 className={`text-3xl font-bold mb-8 ${theme.textPrimary}`}>Service Health Check</h1>

        {error && <div className="text-red-500 mb-4 font-semibold">Error: {error}</div>}

        <div className={`${theme.cardBg} ${theme.cardRound} ${theme.cardBorder} ${theme.cardShadow} mb-4 overflow-hidden`}>
          <table className="w-full">
            <thead>
              <tr className={`border-b-2 ${theme.tableBorder}`}>
                <th className={`px-6 py-4 text-left text-lg font-bold ${theme.textPrimary}`}>Service</th>
                <th className={`px-6 py-4 text-left text-lg font-bold ${theme.textPrimary}`}>Status</th>
              </tr>
            </thead>
            <tbody>
              {services.map((service) => (
                <tr key={service.name} className={`border-b ${theme.tableBorder} ${theme.tableRowHover} transition-colors`}>
                  <td className={`px-6 py-4 text-base font-semibold ${theme.textPrimary}`}>{service.name}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-block rounded-full px-4 py-1 text-base font-semibold
                      ${service.status === "Healthy"
                        ? "bg-emerald-50 text-emerald-700"
                        : "bg-red-50 text-red-700"}`}>
                      {service.status === "Healthy"
                        ? "Healthy"
                        : `Unhealthy: ${service.errorCode}`}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end mt-4">
          <button
            onClick={handleFetchHealth}
            disabled={loading}
            className={`px-5 py-2 rounded-xl text-base font-semibold ${theme.btnPrimary} disabled:opacity-50`}
          >
            {loading ? "Loading..." : "Refresh Status"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HealthCheck;